(function () {
  'use strict';

  var STORAGE_KEY      = 'vz_upsell_seen';
  var COOLDOWN_MS      = 3 * 24 * 60 * 60 * 1000; // 3 days
  var MINICART_SECTION = 'minicart-form';

  var popup          = null;
  var isAddingUpsell = false;
  var userClickedAdd = false;
  var clickResetTimer = null;

  /* ── Cooldown ─────────────────────────────────────────────── */

  function isOnCooldown() {
    try {
      var ts = localStorage.getItem(STORAGE_KEY);
      return ts ? Date.now() - parseInt(ts, 10) < COOLDOWN_MS : false;
    } catch (_) { return false; }
  }

  function setCooldown() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_) {}
  }

  /* ── Popup open / close ───────────────────────────────────── */

  function openPopup() {
    if (!popup || isOnCooldown()) return;
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('vz-upsell--open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('vz-upsell--open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setCooldown();
  }

  /* ── Open sidecart ────────────────────────────────────────── */
  // Called via setTimeout so it runs after the upsell button's click event
  // has fully propagated — cart-notification's handleBodyClick fires on that
  // click (because the upsell popup is outside cart-notification) and calls
  // close(), which removes the 'open' class. We wait 300ms (popup fade is
  // 250ms) then force the drawer open with direct class manipulation.

  function openSideCart() {
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cartEl && cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');

    var wrapper = document.querySelector('#header__minicart .minicart__wrapper');
    if (!wrapper) return;

    wrapper.classList.add('open');
    document.documentElement.classList.add('open-drawer', 'open-minicart');

    // Register the body-click-outside handler so the cart can still be closed normally
    if (cartEl && cartEl.onBodyClick) {
      document.body.addEventListener('click', cartEl.onBodyClick);
    }
  }

  /* ── Update cart count badges ─────────────────────────────── */

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.innerHTML = el.classList.contains('cart-count-drawer')
        ? '(' + count + ')'
        : (count > 100 ? '~' : count);
    });
  }

  /* ── Add upsell product to cart ───────────────────────────── */
  //
  // Sending `sections` in the POST body makes Shopify return the rendered
  // section HTML *in the same response*, guaranteeing the content is fresh.
  // A separate /cart?section_id= fetch races against Shopify's backend and
  // can return stale data — that's why this approach must be used instead.

  function handleAddUpsell(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('vz-upsell--adding');
    btn.textContent = 'adicionando…';

    isAddingUpsell = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: [MINICART_SECTION],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'Erro ao adicionar');

        // Shopify returns the rendered section HTML in the same response —
        // use it directly to avoid any timing issue with a second fetch.
        var sectionHtml = response.sections && response.sections[MINICART_SECTION];
        if (sectionHtml) {
          var doc      = new DOMParser().parseFromString(sectionHtml, 'text/html');
          var incoming = doc.querySelector('#' + MINICART_SECTION);
          var target   = document.getElementById(MINICART_SECTION);
          if (incoming && target) target.innerHTML = incoming.innerHTML;
        }

        // Update cart count from the items list in the response
        var items = response.items || (response.id ? [response] : []);
        if (items.length) {
          fetch('/cart.json')
            .then(function (r) { return r.json(); })
            .then(function (c) { updateCartCount(c.item_count || 0); })
            .catch(function () {});
        }

        btn.textContent = '✓ adicionado';
        // Popup closes → sidecart (which stayed open thanks to stopPropagation) becomes visible
        closePopup();
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('vz-upsell--adding');
        btn.textContent = 'adicionar ao carrinho';
      })
      .finally(function () {
        isAddingUpsell = false;
      });
  }

  /* ── Intercept window.fetch to detect main add-to-cart ───── */

  function interceptFetch() {
    var originalFetch = window.fetch;

    window.fetch = function () {
      var args    = Array.prototype.slice.call(arguments);
      var url     = typeof args[0] === 'string' ? args[0]
                  : (args[0] && typeof args[0].url === 'string') ? args[0].url
                  : '';
      var promise = originalFetch.apply(window, args);

      if (userClickedAdd && !isAddingUpsell && url.indexOf('/cart/add') !== -1) {
        userClickedAdd = false;
        clearTimeout(clickResetTimer);
        promise.then(function (response) {
          if (response && response.ok) setTimeout(openPopup, 400);
        }).catch(function () {});
      }

      return promise;
    };
  }

  /* ── Capture add-to-cart clicks from the page ─────────────── */

  function setupButtonListeners() {
    document.addEventListener('click', function (e) {
      if (isAddingUpsell) return;
      var btn = e.target.closest(
        'button[name="add"], [data-add-to-cart], .product-item__product-form button[type="submit"]'
      );
      if (!btn) return;
      userClickedAdd = true;
      clearTimeout(clickResetTimer);
      clickResetTimer = setTimeout(function () { userClickedAdd = false; }, 4000);
    }, true);
  }

  /* ── Init ─────────────────────────────────────────────────── */

  function init() {
    popup = document.getElementById('vz-upsell-popup');
    if (!popup) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('vz-upsell--animated');
      });
    });

    document.getElementById('vz-upsell-close')?.addEventListener('click', closePopup);
    document.getElementById('vz-upsell-skip')?.addEventListener('click', closePopup);

    popup.addEventListener('click', function (e) {
      var pill = e.target.closest('.vz-upsell__variant-pill');
      if (pill && !pill.disabled) {
        var item = pill.closest('.vz-upsell__item');
        item.querySelectorAll('.vz-upsell__variant-pill').forEach(function (p) {
          p.classList.remove('active');
        });
        pill.classList.add('active');
        var addBtn = item.querySelector('.vz-upsell__card-btn');
        if (addBtn) addBtn.setAttribute('data-variant-id', pill.getAttribute('data-variant-id'));
        var imgEl = item.querySelector('.vz-upsell__item-img-wrap img');
        var newSrc = pill.getAttribute('data-image');
        if (imgEl && newSrc) imgEl.src = newSrc;
        return;
      }

      var btn = e.target.closest('.vz-upsell__card-btn');
      if (btn) {
        // Stop bubbling so cart-notification's handleBodyClick doesn't
        // intercept this click and call close() — the sidecart must stay
        // open while we add the item and update the content.
        e.stopPropagation();
        handleAddUpsell(btn);
        return;
      }
      if (e.target === popup) closePopup();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    interceptFetch();
    setupButtonListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
